export default {
  "pl": {
    "validation": {
      "emailTaken": "Ten adres e-mail jest już w użyciu",
      "import": {
        "inclusion": "Błąd w wierszu {rowNumber}, kolumna {columnNumber}: {headerName} nie znajduje się na liście",
        "inclusion_values": "z dozwolonymi wartościami: {wartości}",
        "invalid": "Błąd w wierszu {rowNumber}, kolumna {columnNumber}: {headerName} jest nieprawidłowy",
        "required": "Błąd w wierszu {rowNumber}, kolumnie {columnNumber}: wymagana jest wartość {headerName}",
        "unique": "Błąd w wierszu {rowNumber}: {headerName} nie jest unikalny, istnieje inny wiersz z tą wartością"
      },
      "nameAlreadyTaken": "Ta nazwa jest już zajęta",
      "needCompany": "Należy podać nazwę firmy",
      "needName": "Należy podać nazwę"
    }
  }
}
